// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {useContext, useState, useMemo, Fragment} from 'react';
import cn from 'classnames';
// @ts-ignore
import {hola_apps} from '../install_constants';
// @ts-ignore
import {get_link, get_exe_link} from '../install_links';
// @ts-ignore
import {ga_track_download_send} from '../ga';
import hola_versions from 'svc_versions';
import {use_download} from '../ui/use_download';
import {Settings_context} from '../settings_ctx';
import {App_context} from 'hola_app_context';
import {Editor} from '../../../shared/editor/editor';
import {Tab_buttons} from '../ui/premium/tab_buttons';
import {Svg_img} from '../ui/svg_img';
import {Button} from '../lib/button';
import styles from './products_tabs.module.less';

const get_version = name=>{
    switch (name)
    {
    case 'browser_mac':
        return hola_versions.chromium_br_mac_build_0_percent;
    case 'browser':
    case 'windows':
    case 'windows32':
    case 'windows64':
        return hola_versions.windows_0_percent;
    case 'windows32beta':
    case 'windows64beta':
        return hola_versions.windows_beta;
    case 'firefox':
        return hola_versions.firefox_full;
    case 'android_beta_arm':
    case 'android_beta_x86':
        return hola_versions.android_5_percent + ' Beta';
    case 'android_arm':
    case 'android_x86':
    case 'androidtv':
        return hola_versions.android;
    case 'mac_beta':
        return hola_versions.iosmac2e;
    default:
        return hola_versions[name];
    }
};

interface i_product {
    name: string,
    type?: string;
    title: string;
    compatibility?: string;
    href?: string;
    icon_id: string;
}

const products: {[p: string]: i_product} = {
    chrome: {
        name: 'chrome',
        type: 'browsers',
        title: 'Chrome extension',
        compatibility: 'Windows / Mac / Linux',
        icon_id: 'svg/pl/ic-chrome2.svg',
    },
    edge: {
        name: 'edge',
        type: 'browsers',
        title: 'Microsoft Edge add-on',
        compatibility: 'Windows / Mac / Linux',
        icon_id: 'svg/pl/ic-edge2.svg',
    },
    opera: {
        name: 'opera',
        type: 'browsers',
        title: 'Opera extension',
        compatibility: 'Windows / Mac / Linux',
        icon_id: 'svg/pl/ic-opera2.svg',
    },
    android: {
        name: 'android',
        type: 'mobile',
        title: 'Android',
        compatibility: 'Android 5.0 and above',
        icon_id: 'svg/pl/ic-android-active.svg',
    },
    ios: {
        name: 'ios',
        type: 'mobile',
        title: 'iOS',
        compatibility: 'iOS 12.0 and above',
        icon_id: 'svg/pl/ic-apple2.svg',
    },
    huawei: {
        name: 'huawei',
        type: 'mobile',
        title: 'Huawei',
        compatibility: 'Android 5.0 and above',
        icon_id: 'svg/pl/ic-huawei2.svg',
    },
    samsung: {
        name: 'samsung',
        type: 'mobile',
        title: 'Samsung',
        compatibility: 'Android 5.0 and above',
        icon_id: 'svg/pl/ic-samsung2.svg',
    },
    hola_browser_win: {
        name: 'browser',
        title: 'Hola Browser',
        compatibility: 'Windows 10, 11',
        href: get_exe_link({hola_browser: true, os: 'windows'}),
        icon_id: 'svg/pl/ic-hola-browser2.svg',
    },
    hola_browser_mac: {
        name: 'browser_mac',
        title: 'Hola Browser',
        compatibility: 'macOS 10.13 and above',
        href: get_exe_link({hola_browser: true, os: 'macos',
            version: hola_versions.mac_installer}),
        icon_id: 'svg/pl/ic-hola-browser2.svg',
    },
    windows: {
        name: 'windows',
        type: 'desktop',
        title: 'Windows',
        compatibility: 'Windows 10, 11',
        icon_id: 'svg/pl/ic-windows2.svg',
    },
    macos: {
        name: 'mac_beta',
        type: 'desktop',
        title: 'macOS',
        compatibility: 'macOS 10.15 and above',
        icon_id: 'svg/pl/ic-macos2.svg',
    },
    firetv: {
        name: 'firetv',
        type: 'tv',
        title: 'Fire TV',
        icon_id: 'svg/pl/ic-firetv2.svg',
    },
    lg: {
        name: 'lg',
        type: 'tv',
        title: 'LG',
        icon_id: 'svg/pl/ic-lg2.svg',
    },
    appletv: {
        name: 'appletv',
        type: 'tv',
        title: 'Apple TV',
        icon_id: 'svg/pl/ic-appletv2.svg',
    },
    smarttv: {
        name: 'smarttv',
        type: 'tv',
        title: 'Smart TV',
        icon_id: 'svg/pl/ic-smarttv2.svg',
    },
    xbox: {
        name: 'xbox',
        type: 'other',
        title: 'Xbox',
        icon_id: 'svg/pl/ic-xbox2.svg',
    },
    playstation: {
        name: 'playstation',
        type: 'other',
        title: 'PlayStation',
        icon_id: 'svg/pl/ic-playstation2.svg',
    },
    routers: {
        name: 'router',
        type: 'other',
        title: 'Routers',
        icon_id: 'svg/pl/ic-routers2.svg',
    },
};
const SETUP_GUIDE_PRODUCTS = [
    'routers',
    'playstation',
    'xbox',
    'smarttv'
];

const BROWSERS = [
    'hola_browser_win',
    'hola_browser_mac',
];

const PLATFORMS = [
    'windows', 'mac', 'mac_beta'
];

const Product = ({id}: {id: string})=>{
    const {name, type, title, compatibility, href, icon_id} = products[id];
    const {theme} = useContext(Settings_context);
    const {has_svc, svc_info} = useContext(App_context);
    const has_setup = SETUP_GUIDE_PRODUCTS.includes(id) ;
    const download_link = get_link({has_svc, svc_info, item: {name,
        href: href || hola_apps[type]?.find(p=>p.name==name)?.href}});
    const {download_br} = use_download();
    const on_download = ()=>{
        download_br({cb: ()=>{
          // waiting for iframe to start actial downloading
          setTimeout(()=>{
              // absolute link for holabrowser.com
              window.location.href =
                  'https://hola.org/after_download?s=install&browser=1';
          }, 1000);
        }});
    };
    return <div className={styles.product}>
      <div className={styles.product_title}>
        <Svg_img id={icon_id} w={20} h={20} cls={styles.product_icon}/>
        <p className={cn(theme.p3, theme.med)}>{title}</p>
      </div>
      <p className={cn(theme.p3, theme.reg, styles.product_compatibility)}>
        {compatibility}</p>
      <p className={cn(theme.p3, theme.reg, styles.product_version)}>
        {get_version(name)}</p>
      <div className={styles.button_wrapper}>
        <Button caption={has_setup ? 'Setup guide' : 'Download'}
          w100={true}
          to={BROWSERS.includes(id) ? null : download_link}
          cls={styles.download_button} size="xs" color="white"
          icon_right={!has_setup && <Svg_img
            id={'hola2023/icons/16/download.svg'} w={12} h={12}/>}
          on_click={()=>{
            if (BROWSERS.includes(id))
              return on_download();
            if (PLATFORMS.includes(name))
            {
              ga_track_download_send(name=='windows' ? 'exe' : 'dmg',
                'downloads', download_link, null, undefined, {});
            }
          }}/>
      </div>
    </div>;
};

const Browsers = ()=>{
    return <Fragment>
      <Product id="chrome"/>
      <Product id="edge"/>
      <Product id="opera"/>
    </Fragment>;
};

const Mobile = ()=>{
    return <Fragment>
      <Product id="android"/>
      <Product id="ios"/>
      <Product id="huawei"/>
      <Product id="samsung"/>
    </Fragment>;
};

const Desktop = ()=>{
    const {theme} = useContext(Settings_context);
    return <Fragment>
      <p className={cn(theme.p3, theme.med, styles.hola_browser_section)}>
        Hola Browser</p>
      <Product id="hola_browser_win"/>
      <Product id="hola_browser_mac"/>
      <p className={cn(theme.p3, theme.med, styles.desktop_apps_section)}>
        Desktop Apps</p>
      <Product id="windows"/>
      <Product id="macos"/>
    </Fragment>;
};

const TV = ()=>{
    return <Fragment>
      <Product id="firetv"/>
      <Product id="lg"/>
      <Product id="appletv"/>
      <Product id="smarttv"/>
    </Fragment>;
};

const Other = ()=>{
    return <Fragment>
      <Product id="xbox"/>
      <Product id="playstation"/>
      <Product id="routers"/>
    </Fragment>;
};

interface i_product_tabs {
    browsers: boolean;
    mobile: boolean;
    desktop: boolean;
    tv: boolean;
    other: boolean;
}

export const Products_tabs = (props: i_product_tabs)=>{
    const [active_tab, set_active_tab] = useState<string>('desktop');
    const tabs = useMemo(()=>{
      const list = [];
      if (props.browsers)
        list.push({id: 'browsers', title: 'Browsers', component: <Browsers/>});
      if (props.mobile)
        list.push({id: 'mobile', title: 'Mobile', component: <Mobile/>});
      if (props.desktop)
        list.push({id: 'desktop', title: 'Desktop', component: <Desktop/>});
      if (props.tv)
        list.push({id: 'tv', title: 'TV', component: <TV/>});
      if (props.other)
        list.push({id: 'other', title: 'other', component: <Other/>});
      return list;
    }, []);
    return <Fragment>
      <Tab_buttons items={tabs} active={active_tab} on_change={set_active_tab}
        sliding class_name={styles.tab_buttons}/>
      <div className={styles.products}>
        {tabs.length && tabs.find(t=>t.id==active_tab).component}
      </div>
    </Fragment>;
};

interface i_product_tabs_editor {
    value: i_product_tabs;
    on_change: (new_value: i_product_tabs)=>void;
}

export const Products_tabs_editor = (props: i_product_tabs_editor)=>{
    const {value = {browsers: true, mobile: true,
      desktop: true, tv: true, other: true}, on_change} = props;
    type editor_key = keyof i_product_tabs;
    type editor_type = 'text' | 'textarea' | 'number' | 'boolean' | 'selector';
    const editors = [
        ['browsers', 'Browsers', 'boolean'],
        ['mobile', 'Mobile', 'boolean'],
        ['desktop', 'Desktop', 'boolean'],
        ['tv', 'TV', 'boolean'],
        ['other', 'Other', 'boolean'],
    ].map(([key, label, type])=>({key: key as editor_key, label,
        type: type as editor_type}));
    return <Editor
      value={value}
      editors={editors}
      on_change={on_change}
      title="Products Tabs"
    />;
};
